import { IFleetEventUIDto, FleetEventUIDto } from "@/lib/dto/event/event-ui.dto";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";
import eventFleetService from "@/services/mrfiktiv/services/fleet/eventFleetService";
import { BaseStore } from "@/store/base.store";
import store from "@/store/VuexPlugin";
import Vue from "vue";
import { Action, Module, Mutation, getModule } from "vuex-module-decorators";
import { PaginationFilterListElement } from "../base-pagination.store";
import { FleetEventDataAccessLayer } from "../access-layers/fleet-event.access-layer";
import { PageFilterElement } from "@/models/page-filter-element.entity";

@Module({
  dynamic: true,
  namespaced: true,
  name: "acknowledgedEventFleetStore",
  store
})
export class AcknowledgedEventFleetStore extends BaseStore<IFleetEventUIDto> {
  _data = FleetEventDataAccessLayer;

  hiddenFilter = [
    new PageFilterElement({
      key: "ack",
      operation: "$ne",
      value: undefined
    })
  ];

  protected _dateRange: string[] = [new Date(1).toISOString(), new Date().toISOString()];

  get dateRange(): string[] {
    return this._dateRange;
  }

  @Mutation
  _mutateDateRange(dateRange: string[]) {
    this._dateRange = dateRange;
  }

  @Action
  setDateRange(dateRange: string[]) {
    this.context.commit("_mutateDateRange", dateRange);
  }

  filterOptions: PaginationFilterListElement[] = [
    { key: "summary", type: PageFilterTypes.STRING, displayName: "objects.event.summary" },
    { key: "description", type: PageFilterTypes.STRING, displayName: "objects.event.description" },
    { key: "start", type: PageFilterTypes.DATE, displayName: "objects.event.start" },
    { key: "end", type: PageFilterTypes.DATE, displayName: "objects.event.end" }
  ].map((f) => new PaginationFilterListElement(f));

  @Action
  async fetchAll(data: { partnerId: string; fleetId: string }) {
    const events = await eventFleetService.list({
      partnerId: data.partnerId,
      fleetId: data.fleetId,
      from: new Date(this._dateRange[0]).getTime() || 1,
      to: new Date(this._dateRange[1]).getTime() || new Date().getTime()
    });

    const acknowledgedEvents = (events ?? []).filter((e) => !!e.ack?.at);

    this._data.clear();
    for (const event of acknowledgedEvents) {
      this._data.set(new FleetEventUIDto(event));
    }

    Vue.$log.debug("Loaded acknowledged fleet events:", acknowledgedEvents.length);
    return acknowledgedEvents;
  }
}

export const AcknowledgedEventFleetModule = getModule(AcknowledgedEventFleetStore);
